import { ERROR_PAGE } from 'client/constants/routes';

function apiClientCatchError(req, res) {
	if (typeof window === 'undefined') {
		return res;
	}

	const isInErrorPage = window.location.pathname === ERROR_PAGE;

	if (!isInErrorPage) {
		window.location.replace(`${ERROR_PAGE}?r=${window.location.pathname}`);
	}

	return res;
}

/**
 * @param {object} req - request object
 * @param {object} res - response object
 * @param {object} options - request options
 * @return res
 */
function apiResponse(req, res, options) {
	return res;
}

export { apiClientCatchError, apiResponse };
